import * as Signalr from '@microsoft/signalr'
import axios from '../http'
import router from '../router/index'

Object.defineProperty(WebSocket, 'OPEN', {
  value: 1,
});
//https://ap2.bjcreate.net
//https://corpcswechatstaging.nestlechinese.com/chatRoomCreate/ 测试
//https://corpcswechat.nestlechinese.com/chatRoomCreate/   正式
// https://corpcswechatstg.nestlechinese.com/
const reconnectedArr = [0, 2000, 4000, 6000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000];
let reconnectedCount = 0;
let $this = this;
const connection = new Signalr.HubConnectionBuilder()
  .withUrl('https://corpcswechat.nestlechinese.com/chatRoomCreate/', {
    accessTokenFactory: () => {
      let obj = window.localStorage.getItem('USER_INFO')
      if (obj != null) {
        let objr = JSON.parse(obj);
        let token = objr.token.replace("Bearer ",
          "");
        return token
      } else {
        localStorage.clear()
				router.push({ path: '/login' })
      }
      // return null;
    }
  })
  .configureLogging(Signalr.LogLevel.Error)
  .withAutomaticReconnect(reconnectedArr)
  .build()
  connection.serverTimeoutInMilliseconds = 30000; //30秒
  connection.keepAliveIntervalInmillisecods = 15000; //15秒

async function start() {
  try {
    await connection.start();
  } catch (err) {

    console.log(err);
    setTimeout(() => start(), 5000);
  }
};
connection.onclose((error) => {
  document.getElementById("modelDiv").style.cssText = "display:block";
  document.getElementById("model").style.cssText = "display:block";
  var str = document.getElementById("model");
  str.getElementsByTagName("i")[0].className = "el-icon-close";
  str.getElementsByTagName("span")[0].innerText = "重连失败,请联系管理员或刷新重试。";

});
connection.onreconnecting(err => {
  reconnectedCount += 1;
  
  if (reconnectedCount >= 8 && connection.state !== Signalr.HubConnectionState.Connected) {
    document.getElementById("modelDiv").style.cssText = "display:block";
    document.getElementById("model").style.cssText = "display:block";
  }
  console.log(err);
  start();
})
connection.onreconnected(connectionId => {
  document.getElementById("modelDiv").style.cssText = "display:none";
  document.getElementById("model").style.cssText = "display:none";
  if (reconnectedCount >= 8 && connection.state !== Signalr.HubConnection.Connected) {
    alert("重连成功!");
  }
  reconnectedCount = 0
  // //自动重连后更新后台
  // axios
  //   .get('User/AddSC', {
  //     params: {
  //       connId: connectionId
  //     }
  //   })
  //   .then(response => {
  //     if (!response.data.result) {
  //       alert(response.data.message)
       
  //     }
  //   })
})
export function SignarStart() {
   
  if (connection.state !== Signalr.HubConnectionState.Connected) {
    connection.start()
  } else {}
}
export default {
  // install方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function (Vue) {
    Vue.prototype.connection = connection;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utilsSignar.js